import { quitlineFor, regionOf } from '@tahi/core';
import { useNavigate } from 'react-router';
import { savePlan } from '../../../data/commands/quit';
import { useCommandEnv, useData, useUsable } from '../../../data/hooks';
import { getBudgetSettingsView, listFunds } from '../../../data/repos/budget';
import { useQuery } from '../../../data/useQuery';
import { showToast } from '../../../ui/toast';
import { copy, errorText } from '../copy';
import { QUIT_BASE } from '../dashboardDefaults';
import { useQuitData, useQuitToday } from '../hooks';
import { draftFromPlan } from '../planDraft';
import { SCREEN } from '../styles';
import { PlanWizard } from './PlanWizard';

export function PlanRoute() {
  const env = useCommandEnv();
  const navigate = useNavigate();
  const { userId } = useData();
  const budgetOn = useUsable()('budget');
  const data = useQuitData();
  const today = useQuitToday();
  const { data: funds } = useQuery(
    ['funds', 'budget_settings'],
    // v0.5: the limit picker shows only while spending limits are on.
    async (db) =>
      budgetOn && (await getBudgetSettingsView(db, userId)).useFunds ? listFunds(db, userId) : null,
    [userId, budgetOn],
  );

  if (!data) {
    return (
      <main className={SCREEN}>
        <p role="status" className="text-muted">
          {copy.loading}
        </p>
      </main>
    );
  }

  const deviceRegion = typeof navigator === 'undefined' ? null : regionOf(navigator.language);
  return (
    <PlanWizard
      key={data.plan ? 'edit' : 'new'}
      mode={data.plan ? 'edit' : 'new'}
      initial={data.plan ? draftFromPlan(data.plan, today) : null}
      today={today}
      defaultCountry={quitlineFor(deviceRegion).country}
      funds={funds ?? null}
      onSave={async (draft) => {
        const r = await savePlan(env, draft);
        if (!r.ok) return errorText(r.error);
        showToast({ message: copy.planSaved });
        navigate(QUIT_BASE, { replace: true });
        return null;
      }}
    />
  );
}
